import { Box, Flex, SimpleGrid, Text, useDisclosure } from "@chakra-ui/react";

import React, { useCallback, useEffect, useState } from "react";

import { useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import {
  Permission,
  referenciaFunc,
  visitasFunc,
  vrCriancaFunc,
  criancaFunc,
} from "../../../../../../helpers/Funcionalidades";
import CriancaService from "../../../../../../main/services/CriancaService";
import { CustomButton } from "../../../../../components/CustomButton";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import SemRegistros from "../../../../../components/SemRegistros";
import { IrmaoTable } from "../../../ReferenciaFamiliar/Irmaos/Table";
import { RestricoesModal } from "../Restricoes/RestricoesModal";
import Group from "../../../../ServicosAcolhimento/Visualizar/Group";
import { VisitaModal } from "../Cadastrar/VisitaModal";
import VisitasService from "../../../../../../main/services/VisitasService";
import RestricaoService from "../../../../../../main/services/RestricaoService";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { IconeDownload } from "../../../../../components/IconeDownload";
import { normalizeString } from "../../../../../utils/masks";
import { useAuthProvider } from "../../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../../utils/scrollToFIeldAnexo";
import { useHistory } from "react-router-dom";
import { deleteUrlParam } from "../../../../../utils/deleteUrlParam";

export const VisualizarVisita = ({ setLoadingPainel }) => {
  const {
    isOpen: isOpenCadastrarVisita,
    onOpen: onOpenCadastrarVisita,
    onClose: onCloseCadastrarVisita,
  } = useDisclosure();
  const {
    isOpen: isOpenCadastrarRestricoes,
    onOpen: onOpenCadastrarRestricoes,
    onClose: onCloseCadastrarRestricoes,
  } = useDisclosure();

  const { id } = useParams();
  const [data, setData] = useState([]);
  const { filiacao, situacaoMovimento, idPJ } = useAppContext();
  const [dataRestricoes, setDataRestricoes] = useState([]);
  const [relations, setRelations] = useState({ options: [], isLoading: false });
  const [loadingVisitas, setLoadingVisitas] = useState(false);
  const [loadingRestricoes, setLoadingRestricoes] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const [referenciaFamiliar, setReferenciaFamiliar] = useState([]);
  const [situacao, setSituacao] = useState("");
  const history = useHistory();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia]
  );

  const getDownloadRestricao = (idCrianca, idRestricao) => {
    RestricaoService.getAnexoTermoRestricao(idCrianca, idRestricao)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDownloadLiberacao = (idCrianca, idRestricao) => {
    RestricaoService.getAnexoTermoLiberacao(idCrianca, idRestricao)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columnsVisitas = [
    {
      Header: "Nome",
      accessor: "nomeVisitante",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
    },
    {
      Header: "Data da última visita",
      accessor: "ultimaVisita",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{custom_date ? custom_date : ""}</span>;
      },
    },
    {
      Header: "Último mês",
      accessor: "ultimoMes",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Últimos 3 meses",
      accessor: "ultimoTresMeses",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Últimos 6 meses",
      accessor: "ultimoSeisMeses",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
  ];

  const columnsRestricoes = [
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Nome",
      accessor: "pessoaRestricao.nome",
      Cell: (props) => {
        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={"break-all"}
          >
            {props.value}
          </Text>
        );
      },
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
    },
    {
      Header: "Decisão de proibição",
      accessor: "possuiAnexoRestricao",
      Cell: (props) => {
        const idRestricao = props.row.original.idRestricao;
        return (
          <span>
            {props.value ? (
              <Flex justifyContent={"center"}>
                <button onClick={() => getDownloadRestricao(id, idRestricao)}>
                  <IconeDownload />
                </button>
              </Flex>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Data de proibição",
      accessor: "dataProibicao",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{props.value ? custom_date : ""}</span>;
      },
      disableSortBy: true,
    },
    {
      Header: "Decisão de liberação",
      accessor: "possuiAnexoLiberacao",
      Cell: (props) => {
        const idRestricao = props.row.original.idRestricao;
        return (
          <span>
            {props.value ? (
              <Flex justifyContent={"center"}>
                <button onClick={() => getDownloadLiberacao(id, idRestricao)}>
                  <IconeDownload />
                </button>
              </Flex>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Data de liberação",
      accessor: "dataLiberacao",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{props.value ? custom_date : ""}</span>;
      },
      disableSortBy: true,
    },
  ];

  const handleGetRelacionamento = useCallback(() => {
    setRelations((prev) => ({ ...prev, isLoading: true }));

    RestricaoService.getRelacionamentoRestricao(id).then((res) => {
      setRelations({ options: res.data, isLoading: false });
    });
  }, [id]);

  const fetchVisitasData = useCallback(() => {
    setLoadingVisitas(true);
    VisitasService.visualizarVisitaCrianca(id)
      .then((res) => {
        setData(res.data.content);
        setLoadingVisitas(false);
        setLoadingPainel(false);
      })
      .catch((error) => {
        console.log("Error no getVisita", error);
        setLoadingVisitas(false);
        setLoadingPainel(false);
      });
  }, [id, setLoadingPainel]);

  useEffect(() => {
    const handleGetReferencia = () => {
      CriancaService.getReferencia(id)
        .then((res) => {
          setReferenciaFamiliar(res.data);
        })
        .catch((error) => {
          setReferenciaFamiliar([]);
        });
    };
    handleGetReferencia();
  }, [id]);

  const fetchDataRestricoes = useCallback(() => {
    setLoadingRestricoes(true);
    RestricaoService.listaRestricao(id)
      .then((res) => {
        const data = res.data.content;

        const ordenado = data.sort((a, b) => {
          if (a.status === b.status) {
            if (a.status === "Proibido") {
              if (a.dataProibicao === b.dataProibicao) {
                return a.pessoaRestricao.nome.localeCompare(
                  b.pessoaRestricao.nome
                );
              }
              return b.dataProibicao - a.dataProibicao;
            } else {
              if (a.dataLiberacao === b.dataLiberacao) {
                return a.pessoaRestricao.nome.localeCompare(
                  b.pessoaRestricao.nome
                );
              }
              return b.dataLiberacao - a.dataLiberacao;
            }
          } else {
            return a.status === "Proibido" ? -1 : 1;
          }
        });

        setDataRestricoes(ordenado);
        setLoadingRestricoes(false);
      })
      .catch((error) => {
        setDataRestricoes(null);
        console.log("Error no getReferencia", error);
        setLoadingRestricoes(false);
      });
  }, [id]);

  const deleteReferencia = (idRelacionamento, onClose) => {
    CriancaService.deleteReferencia(id, idRelacionamento)
      .then((res) => {
        if (id) {
          fetchVisitasData();
        }

        Swal.fire({
          title: "Sucesso!",
          text: "Sucesso! Registro inativado com sucesso!",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#169499",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
          }
        });
      })
      .catch((error) => {
        console.log(error.response.data);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message ? error.response.data.message : "",
          icon: "error",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        });
      });
  };

  const deleteRestricoes = (idRestricao, onClose) => {
    RestricaoService.deleteRestricao(id, idRestricao)
      .then((res) => {
        fetchDataRestricoes();
        deleteUrlParam("idAnexo", history);
        Swal.fire({
          title: "Sucesso!",
          text: "Registro Excluído.",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#169499",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
          }
        });
      })
      .catch((error) => {
        console.log(error.response.data);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message ? error.response.data.message : "",
          icon: "error",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        });
      });
  };

  useEffect(() => {
    fetchVisitasData();
    fetchDataRestricoes();
    handleGetRelacionamento();
  }, [fetchVisitasData, fetchDataRestricoes, handleGetRelacionamento]);

  useEffect(() => {
    if (
      situacaoMovimento &&
      situacaoMovimento.motivoSituacao &&
      situacaoMovimento.motivoSituacao.tipoSituacao.descricao === "Acolhido"
    ) {
      setSituacao("Acolhido");
    } else if (
      situacaoMovimento &&
      situacaoMovimento.motivoSituacao &&
      situacaoMovimento.motivoSituacao.tipoSituacao.descricao === "Desligado"
    ) {
      setSituacao("Desligado");
    } else if (
      !situacaoMovimento.motivoSituacao &&
      !situacaoMovimento.movimentoMovimentacao
    ) {
      setSituacao("Pendente");
    } else if (
      !situacaoMovimento.motivoSituacao &&
      situacaoMovimento?.movimentoMovimentacao?.tipoSituacaoMovimentacao
        ?.descricao
    ) {
      setSituacao(
        situacaoMovimento?.movimentoMovimentacao?.tipoSituacaoMovimentacao
          ?.descricao
      );
    } else {
      setSituacao("");
    }
  }, [situacaoMovimento]);

  return (
    <>
      {roleKeycloack &&
      (roleKeycloack?.includes(vrCriancaFunc.visitaCriancaVisualizar) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ))) ? (
        <>
          <Group
            title="VISITAS"
            minHeight={"118px"}
            border={
              ["42", "43"].includes(idTipoPendencia)
                ? "3px solid #4299E199"
                : ""
            }
            scrollToField={
              ["42", "43"].includes(idTipoPendencia) && !loadingVisitas
                ? scrollToField
                : null
            }
          >
            <SimpleGrid
              mt="30px"
              columns={{ base: 1, sm: 2, lg: 5 }}
              spacing="20px"
              marginTop={"-50px"}
              dir="rtl"
            >
              <Permission
                roleKeycloack={roleKeycloack}
                func={vrCriancaFunc.visitaCriancaCadastrar}
                user={user}
                id={idPJ}
              >
                {situacao === "Acolhido" ? (
                  <CustomButton
                    width={{ base: "50%", md: "auto" }}
                    label="Cadastrar"
                    isDisabled={
                      relations.options &&
                      relations.options.length <= 0 &&
                      referenciaFamiliar &&
                      referenciaFamiliar.length <= 0 &&
                      filiacao.every(
                        (item) =>
                          item.id === null ||
                          normalizeString(item.filiacao.nome) ===
                            normalizeString("Sem Informação") ||
                          (item.filiacao.falecido &&
                            item.filiacao.falecido === "S")
                      )
                    }
                    buttonBlocked={true}
                    onClick={() => {
                      onOpenCadastrarVisita();
                    }}
                  />
                ) : (situacao === "Desligado" || situacao === "Pendente") &&
                  roleKeycloack &&
                  roleKeycloack.includes(
                    visitasFunc.visitaCriancaDpCadastrar
                  ) ? (
                  <CustomButton
                    width={{ base: "50%", md: "auto" }}
                    label="Cadastrar"
                    isDisabled={
                      relations.options &&
                      relations.options.length <= 0 &&
                      referenciaFamiliar &&
                      referenciaFamiliar.length <= 0 &&
                      filiacao.every(
                        (item) =>
                          item.id === null ||
                          normalizeString(item.filiacao.nome) ===
                            normalizeString("Sem Informação") ||
                          (item.filiacao.falecido &&
                            item.filiacao.falecido === "S")
                      )
                    }
                    buttonBlocked={true}
                    onClick={() => {
                      onOpenCadastrarVisita();
                    }}
                  />
                ) : (
                  <Box h={"42px"} />
                )}
              </Permission>
              <VisitaModal
                isOpen={isOpenCadastrarVisita}
                onOpen={onOpenCadastrarVisita}
                idCrianca={id}
                onClose={() => {
                  onCloseCadastrarVisita();
                }}
                roleKeycloack={roleKeycloack}
                fetchVisitasData={fetchVisitasData}
              />
            </SimpleGrid>
            {!loadingVisitas ? (
              <>
                {data && data.length > 0 ? (
                  <Box
                    mt={
                      roleKeycloack?.includes(referenciaFunc.referenciaIncluir)
                        ? 4
                        : 20
                    }
                  >
                    <IrmaoTable
                      columns={columnsVisitas}
                      data={data}
                      filiacoes={data}
                      entidade="visitas"
                      visitas={true}
                      deleteReferencia={deleteReferencia}
                      idCrianca={id}
                    />
                  </Box>
                ) : (
                  <Box
                    mt={
                      roleKeycloack?.includes(referenciaFunc.referenciaIncluir)
                        ? 4
                        : 20
                    }
                  >
                    <SemRegistros half buttonVisible={true} />
                  </Box>
                )}
              </>
            ) : (
              <Box mt="2">
                <LoadingSpinner />
              </Box>
            )}
          </Group>

          <Group
            title="RESTRIÇÕES"
            minHeight={"118px"}
            border={
              ["8", "9"].includes(idAnexo) ||
              ["44", "45"].includes(idTipoPendencia)
                ? "3px solid #4299E199"
                : ""
            }
            scrollToField={
              (["8", "9"].includes(idAnexo) ||
                ["44", "45"].includes(idTipoPendencia)) &&
              !loadingVisitas
                ? scrollToField
                : null
            }
          >
            <SimpleGrid
              mt="30px"
              columns={{ base: 1, sm: 2, lg: 5 }}
              spacing="20px"
              marginTop={"-50px"}
              dir="rtl"
            >
              <Permission
                roleKeycloack={roleKeycloack}
                func={vrCriancaFunc.restricaoCadastrar}
                user={user}
                id={idPJ}
              >
                <CustomButton
                  width={{ base: "50%", md: "auto" }}
                  label="Cadastrar"
                  isDisabled={
                    relations.options &&
                    relations.options.length <= 0 &&
                    referenciaFamiliar &&
                    referenciaFamiliar.length <= 0 &&
                    filiacao.every(
                      (item) =>
                        item.id === null ||
                        normalizeString(item.filiacao.nome) ===
                          normalizeString("Sem Informação") ||
                        (item.filiacao.falecido &&
                          item.filiacao.falecido === "S")
                    )
                  }
                  buttonBlocked={true}
                  onClick={() => {
                    onOpenCadastrarRestricoes();
                  }}
                />
              </Permission>
              <RestricoesModal
                isOpen={isOpenCadastrarRestricoes}
                onOpen={onOpenCadastrarRestricoes}
                roleKeycloack={roleKeycloack}
                idCrianca={id}
                onClose={() => {
                  onCloseCadastrarRestricoes();
                }}
                fetchDataRestricoes={fetchDataRestricoes}
                relations={relations}
                handleGetRelacionamento={handleGetRelacionamento}
              />
            </SimpleGrid>
            {!loadingRestricoes ? (
              <>
                {dataRestricoes && dataRestricoes.length > 0 ? (
                  <Box
                    mt={
                      roleKeycloack?.includes(
                        vrCriancaFunc.restricaoCadastrar
                      ) ||
                      (roleKeycloack?.includes(
                        criancaFunc.visualizarTudoAcolhimento
                      ) &&
                        user?.orgaoExterno?.includes(idPJ))
                        ? 4
                        : 20
                    }
                  >
                    <IrmaoTable
                      roleKeycloack={roleKeycloack}
                      columns={columnsRestricoes}
                      data={dataRestricoes}
                      entidade={"restricoes"}
                      restricoes={true}
                      filiacoes={dataRestricoes}
                      deleteRestricoes={deleteRestricoes}
                      fetchDataRestricoes={fetchDataRestricoes}
                      idCrianca={id}
                      idPJ={idPJ}
                    />
                  </Box>
                ) : (
                  <Box
                    mt={
                      roleKeycloack?.includes(
                        vrCriancaFunc.restricaoCadastrar
                      ) ||
                      (roleKeycloack?.includes(
                        criancaFunc.visualizarTudoAcolhimento
                      ) &&
                        user?.orgaoExterno?.includes(idPJ))
                        ? 2
                        : 20
                    }
                  >
                    <SemRegistros half buttonVisible={true} />
                  </Box>
                )}
              </>
            ) : (
              <Box mt="2">
                <LoadingSpinner />
              </Box>
            )}
          </Group>
        </>
      ) : (
        <Box mt="2">
          <SemRegistros buttonVisible={true} />
        </Box>
      )}
    </>
  );
};
